import { baseDomain } from '@/common/config'
import { service } from '@/utils/request.js'
import axios from 'axios'

const Api = {
  File_Data: baseDomain + '/education/public/', // 文件详情
  File_Delete: baseDomain + '/education/', // 文件详情
  package_Download: baseDomain + '/embody/packageDownload', // 报文下载
  fileList: baseDomain + '/embody/device/fileList/', // 获取文件列表
  bindRobotList: baseDomain + '/embody/device/bindRobotList/', // 获取边端绑定的机器人列表
}

export const reqFileData = (params) => {
  return service({
    url: Api.File_Data + params.id,
    method: 'GET',
  })
}

export const reqFileDelete = (params) => {
  return service({
    url: Api.File_Delete + params.id,
    method: 'POST',
  })
}

export const reqFile = (url) => {
  return axios({
    url,
    method: 'GET',
    responseType: 'blob',
  })
}

export const reqReportDownload = (params) => {
  return axios({
    url: Api.File_Delete + params.fileName,
    method: 'GET',
  })
}

// export const reqPackageDownload = (params) => {
//   return axios({
//     url: Api.package_Download,
//     method: 'GET',
//     params: params
//   })
// }

export const reqPackageDownload = (params) => {
  // window.open(Api.ErrorLog_Download + '?fileUrl=' + params.fileUrl)
  // window.open(params.fileUrl)
  // return true
  let token = window.localStorage.getItem('token')
  return axios({
    method: 'GET',
    url: Api.package_Download,
    params: params,
    headers: {
      token,
      'Content-Disposition': 'attachment'
    },
    // responseType: 'blob',
  })
}

export const reqFileList = (params) => {
  return service({
    url: Api.fileList + params.uuid,
    method: 'GET',
  })
}

export const reqBindRobotList = (params) => {
  return service({
    url: Api.bindRobotList + params.edgeCode,
    method: 'GET',
  })
}
